export class ExternalFinancialDataStatisticsOutDTO {
  sumSlips!: number;
  sumStakes!: number;
  sumTolls!: number;
  sumWinnings!: number;
  sumDeposits!: number;
  sumWithdrawals!: number;
  sumCancelledStakes!: number;
}
